module.exports = __webpack_public_path__ + "img/pa.2ad7cc29.jpg";